module.exports = __webpack_public_path__ + "static/media/metamask-logo.c1ff6169.svg";